// extracted by mini-css-extract-plugin
module.exports = {"chatEveryoneImg":"ChatWithEveryone_chatEveryoneImg__NDyKt","closeDiv":"ChatWithEveryone_closeDiv__3JyTy"};